// Decorative floral SVG spray — used as a non-interactive corner accent.
// Pointer-events disabled so it never interferes with CTAs or clicks underneath.
// Keep it subtle: soft blush + rose + muted gold leaves, no hard outlines.
export const FloralCorner = ({ className = "", rotate = 0, size = 260, opacity = 0.85, "data-testid": testId = "floral-corner" }) => (
    <svg
        viewBox="0 0 240 240"
        width={size}
        height={size}
        aria-hidden="true"
        className={`pointer-events-none select-none ${className}`}
        style={{ transform: `rotate(${rotate}deg)`, opacity, filter: "drop-shadow(0 6px 24px rgba(226, 125, 152, 0.22))" }}
        data-testid={testId}
    >
        <defs>
            <radialGradient id={`petal-${rotate}`} cx="50%" cy="40%" r="60%">
                <stop offset="0%" stopColor="#FDE4EA" />
                <stop offset="55%" stopColor="#F4B6C4" />
                <stop offset="100%" stopColor="#E27D98" />
            </radialGradient>
            <linearGradient id={`stem-${rotate}`} x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#8A9A6B" stopOpacity="0.75" />
                <stop offset="100%" stopColor="#B08544" stopOpacity="0.85" />
            </linearGradient>
            <radialGradient id={`center-${rotate}`} cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#F3DDA8" />
                <stop offset="100%" stopColor="#B08544" />
            </radialGradient>
        </defs>

        {/* Curving branch */}
        <path d="M 10 20 Q 70 60 110 110 T 220 220" stroke={`url(#stem-${rotate})`} strokeWidth="1.6" fill="none" strokeLinecap="round" />
        <path d="M 30 30 Q 60 80 90 80" stroke={`url(#stem-${rotate})`} strokeWidth="1.2" fill="none" strokeLinecap="round" opacity="0.75" />
        <path d="M 150 140 Q 170 170 150 210" stroke={`url(#stem-${rotate})`} strokeWidth="1.1" fill="none" strokeLinecap="round" opacity="0.65" />

        {/* Leaves */}
        <path d="M 55 55 q 10 -16 24 -8 q -4 18 -24 8 z" fill="#8A9A6B" opacity="0.7" />
        <path d="M 120 115 q 14 -18 28 -6 q -6 20 -28 6 z" fill="#A3B184" opacity="0.65" />
        <path d="M 170 180 q 12 -10 22 -2 q -6 14 -22 2 z" fill="#8A9A6B" opacity="0.65" />

        {/* Flower cluster helper */}
        {[
            { cx: 36, cy: 38, r: 14 },
            { cx: 92, cy: 82, r: 18 },
            { cx: 154, cy: 140, r: 20 },
            { cx: 78, cy: 150, r: 12 },
            { cx: 198, cy: 196, r: 15 },
        ].map((f, i) => (
            <g key={i} transform={`translate(${f.cx} ${f.cy})`}>
                {/* 5 petals */}
                {[0, 72, 144, 216, 288].map((angle) => (
                    <ellipse
                        key={angle}
                        cx="0"
                        cy={-f.r * 0.6}
                        rx={f.r * 0.42}
                        ry={f.r * 0.72}
                        fill={`url(#petal-${rotate})`}
                        transform={`rotate(${angle})`}
                    />
                ))}
                {/* Golden center */}
                <circle r={f.r * 0.3} fill={`url(#center-${rotate})`} />
            </g>
        ))}

        {/* Loose petals drifting */}
        <ellipse cx="14" cy="130" rx="5" ry="8" fill="#F4B6C4" opacity="0.8" transform="rotate(-25 14 130)" />
        <ellipse cx="200" cy="60" rx="4" ry="7" fill="#E27D98" opacity="0.7" transform="rotate(35 200 60)" />
        <ellipse cx="130" cy="60" rx="4" ry="6" fill="#F9CCD6" opacity="0.8" transform="rotate(10 130 60)" />
    </svg>
);
